import React from 'react'

const LeftArrowSorrell = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_431_3829)">
                <path className='group-hover:fill-Gray50' d="M10.3563 17.8832V15.9222L23.5422 8.90332V11.9067L13.9301 16.8724V16.9355L23.5435 21.8999V24.9033L10.3563 17.8832Z" fill="#CCB17B" />
            </g>
            <defs>
                <clipPath id="clip0_431_3829">
                    <rect width="13.1859" height="16" fill="white" transform="translate(10.3563 8.90332)" />
                </clipPath>
            </defs>
        </svg>


    )
}

const LeftArrowWhite = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_431_3827)">
                <path d="M9.85632 17.8832V15.9222L23.0422 8.90332V11.9067L13.4301 16.8724V16.9355L23.0435 21.8999V24.9033L9.85632 17.8832Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_431_3827">
                    <rect width="13.1859" height="16" fill="white" transform="translate(9.85632 8.90332)" />
                </clipPath>
            </defs>
        </svg>


    )
}

const LeftArrowGray = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_431_3831)">
                <path d="M10.3563 17.8832V15.9222L23.5422 8.90332V11.9067L13.9301 16.8724V16.9355L23.5435 21.8999V24.9033L10.3563 17.8832Z" fill="#ACADC1" />
            </g>
            <defs>
                <clipPath id="clip0_431_3831">
                    <rect width="13.1859" height="16" fill="white" transform="translate(10.3563 8.90332)" />
                </clipPath>
            </defs>
        </svg>


    )
}

export { LeftArrowSorrell, LeftArrowWhite, LeftArrowGray }